import React from 'react';
import Head from 'next/head';
import { LoginContainer } from '../../auth';
import { withFlagshipSession } from '../../auth/serverSide';
import { MetaAttributes } from '../../head';
import { server } from '../../config';

const LoginPage = () => {
  return (
    <>
      <Head>
        <script
          type="text/javascript"
          src={`https://bb35779e23f6.edge.sdk.awswaf.com/bb35779e23f6/${server.WEB_ACL_ID}/challenge.js`}
          defer
        />
      </Head>
      <MetaAttributes seoTitle="Login | Ollie" />
      <LoginContainer />
    </>
  );
};

export const getServerSideProps = withFlagshipSession(async context => {
  return {
    props: {},
  };
});

LoginPage.displayName = 'LoginPage';

export default LoginPage;
